import RateOfChange from '../RateOfChange';

const GoldChangeCny = () => {

    return (
        <div className="gold-change">
            <RateOfChange title = "gold_ticker_cny" default = "Gold" currency_ticker = "CNY" />
        </div>
    )
}

export default GoldChangeCny;